import { Auth } from 'aws-amplify';
import { adminUrl, publicUrl } from '../env';

const textCall = async (url, request) => {

    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();

    const response = await fetch(url, {
        
        method: 'POST',
        body: JSON.stringify(request),

        headers:new Headers({
            'Authorization': token
        })

      });
    
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Request failed with status ${response.status}`);
    }
    return response;
};

const apiCall = async (url, request) => (await textCall(url, request)).json();

const marketTextCall = async(request) => (await textCall(publicUrl(), request)).text();
const marketCall = async(request) => await apiCall(publicUrl(), request);
const adminCall = async(request) => await apiCall(adminUrl(), request);
const modelCall = async(modelType, request) => await apiCall(adminUrl(extractNamespace(modelType)), request);
const createCall = async(ModelType, Payload) => await adminCall({ModelType, Payload, Method:"Create"});

const readCall = async(ModelType, key) => await adminCall({ModelType, key, Method: "Read"});
const listByParentCall = async(ModelType, ParentId) => await adminCall({ModelType, Payload: ParentId, Method: "ReadListByParent"});
const extractNamespace = (modelType) => modelType.substr(modelType.lastIndexOf('.') + 1);

export const Api = {
    apiCall,
    adminCall,
    
    marketTextCall,
    marketCall,
    createCall,
    listByParentCall,
    readCall
}